module.exports = __webpack_public_path__ + "static/automation-kr-8eeb84225ab2b6db93b2a4364be61cf2.png";